













































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { EmailRegistrationDTO } from "@/model/data.model";
import { EmailRegistration as EmailRegistrationService } from "@/services/EmailRegistration";
import { cloneDeep } from "lodash";
import equal from "fast-deep-equal";
import { email, required } from "vuelidate/lib/validators";

@Component({
  validations(this: any) {
    return {
      list: {
        $each: {
          email: {
            email,
            required,
            uniqueEmail: (value: string) => {
              if (!value) return true;
              const emails = this.list.map((item: any) => item.email);
              const count = emails.filter((e: string) => e === value).length;
              return count === 1;
            }
          }
        }
      }
    };
  }
})
export default class EmailRegistration extends Vue {
  emailRegistrationService: EmailRegistrationService = new EmailRegistrationService();

  list: EmailRegistrationDTO[] = [];
  defaultItem = {
    email: "",
    sent: false,
    exception: false,
    delivered: false
  } as EmailRegistrationDTO;
  defaultList: EmailRegistrationDTO[] = [];

  get enableSaveBtn() {
    if (equal(this.list, this.defaultList)) return false;
    return !this.$v.$invalid;
  }

  get disableAddNewItem() {
    return this.list.length >= 4;
  }

  addNewItem() {
    this.list.push(cloneDeep(this.defaultItem));
  }

  async loadEmails() {
    try {
      const list = await this.emailRegistrationService.getEmailsList();
      this.list = list.sort(
        (a: EmailRegistrationDTO, b: EmailRegistrationDTO) => {
          const aId = !a ? 0 : a.id;
          const bId = !b ? 0 : b.id;
          if (aId > bId) return 1;
          if (aId < bId) return -1;
          return 0;
        }
      );
      this.defaultList = cloneDeep(this.list);
    } catch (err) {
      console.error(err);
    }
  }

  async deleteEmail(item: EmailRegistrationDTO, index) {
    try {
      if (item.id) {
        await this.emailRegistrationService.deleteEmail(item.email);
      }

      this.list.splice(index, 1);
      this.defaultList = cloneDeep(this.list);
    } catch (err) {
      console.error(err);
    }
  }

  async created() {
    await this.loadEmails();
  }

  async saveData() {
    this.$v.$touch();
    if (this.$v.$invalid) {
      console.log("Data invalid");
      return;
    }

    try {
      for (const [index, el] of this.list.entries()) {
        if (!el.id) {
          await this.emailRegistrationService.createEmailData(el);
        } else {
          const defaultEl = this.defaultList[index]
            ? cloneDeep(this.defaultList[index])
            : null;
          if (!defaultEl || !equal(defaultEl, el)) {
            await this.emailRegistrationService.updateEmailData(el);
          }
        }
      }
      this.loadEmails();
      this.$alerts.success(this.$t("email_registration_success"));
    } catch (err) {
      console.error(err);
    }
  }
}
